import React, { useEffect, useState } from "react";
import { fetchBanners, handleDismiss } from "./banner_functions";

const MobileBanner = () => {
  const [banners, setBanners] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const banners = () => {
      fetchBanners(setBanners, setLoading);
    };

    banners();
  }, []);

  useEffect(() => {
    if (banners.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [banners]);

  if (banners.length === 0 || loading) {
    return null;
  }

  return (
    <div className="banners-container">
      <div className="banner-top">
        <img
          src={banners[currentIndex]?.imageUrl}
          alt={`${banners[currentIndex]?.name}'s banner`}
          className="banner-image"
        />
        <button
          className="dismiss-button"
          onClick={() => handleDismiss(setBanners, setCurrentIndex)}
        >
          X
        </button>
      </div>
    </div>
  );
};

export default MobileBanner;
